<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  
  let {
    headingText,
    headingLevel = 'h2',
    childLinks = [],
    currentPage,
    viewAllLink = undefined,
    sticky = false,
    lang,
    dataTestId = 'article-expander',
    initialDesktopLinks = lang === 'es' ? 4 : 5
  } = $props();

  let showDropdown = $state(false);
  const toggleDropdown = (e) => {
    if (e.type === 'click' || (e.type === 'mouseleave' && showDropdown) || (e.type === 'mouseenter' && !showDropdown)) {
      showDropdown = !showDropdown;
    }
  };

  let hash = $state();
  const handleAnchorClick = (e) => {
    hash = e.target.href.split('#')[1];
    if (hash) {
      showDropdown = !showDropdown;
    }
  };

  $effect.pre(() => {
    hash = window.location.hash.replace('#', '');
  });
</script>

<nav
  data-testid={dataTestId}
  class="relative z-10 w-full bg-blue-robin-egg drop-shadow-sm"
  class:sticky
  class:top-0={sticky}
  class:z-20={sticky}
>
  <button
    onclick={toggleDropdown}
    class="bg-blue-robin-egg px-4 py-3 md:py-4 w-full flex justify-between focus:bg-blue-bright-cyan focus:shadow-inset-focus active:shadow-inset-active active:bg-blue-bright-cyan hover-hover:hover:bg-blue-bright-cyan lg:hidden"
    aria-expanded={showDropdown}
  >
    <svg class="w-6 h-6 mr-2">
      <use xlink:href={`${SPRITESHEET_URL}#menu`} />
    </svg>
    {#if headingText}
      <BaseHeading
        className="text-blue-dark-navy font-medium text-left"
        {headingLevel}
        dataTestId="{dataTestId}-base-heading"
      >
        {headingText}
      </BaseHeading>
    {/if}
    <svg
      class="w-6 h-6 fill-current transition-transform duration-200 ease-in-out ml-auto"
      class:rotate-90={!showDropdown}
      class:-rotate-90={showDropdown}
    >
      <use xlink:href={`${SPRITESHEET_URL}#chevron-right`} />
    </svg>
  </button>
  <!-- desktop -->
  <ul
    onmouseleave={toggleDropdown}
    class="bg-white lg:bg-blue-robin-egg shadow-md overflow-hidden transition-height duration-150 ease-in-out text-0.5sm lg:shadow-none lg:max-h-full lg:max-w-6xl lg:mx-auto lg:flex"
    class:lg:justify-between={initialDesktopLinks < childLinks.length}
    class:max-h-0={!showDropdown}
    class:max-h-auto={showDropdown}
  >
    {#each childLinks.slice(0, initialDesktopLinks) as { url, text, target }}
      <li class="first:pt-2 last:pb-2 lg:first:pt-0 lg:last:pb-0">
        {#if currentPage !== text}
          <BaseLink
            {url}
            {target}
            onClick={handleAnchorClick}
            className={`h-full w-full group flex items-center justify-between px-4 py-3 md:py-4 text-blue-cerulean font-medium text-center hover-hover:hover:text-blue-dark-navy hover-hover:hover:bg-blue-bright-cyan  
            focus:relative focus:outline-none active:shadow-inset-active active:bg-blue-very-light active:text-blue-dark-navy focus:shadow-inset-focus lg:text-blue-dark-navy
            ${hash && hash === url.split('#')[1] && 'bg-blue-very-light'}`}
          >
            {text}
          </BaseLink>
        {:else}
          <div
            class="max-w-max mx-4 mb-2 pt-3 pb-1 border-b-2 border-blue-robin-egg font-medium lg:h-full lg:border-b-0 lg:mb-0 lg:mx-0 lg:px-4 lg:py-4 lg:bg-blue-very-light"
          >
            {text}
          </div>
        {/if}
      </li>
    {/each}
    {#if initialDesktopLinks < childLinks.length}
      <li>
        <button
          onclick={toggleDropdown}
          onmouseenter={toggleDropdown}
          class="hidden lg:flex px-4 py-3 md:py-4 text-blue-dark-navy font-medium focus:shadow-inset-focus active:shadow-inset-active hover-hover:hover:bg-blue-bright-cyan active:bg-gray-mercury"
          class:bg-white={showDropdown}
          aria-expanded={showDropdown}
        >
          {#if viewAllLink}
            {viewAllLink.text}
          {:else}
            More Categories
          {/if}
          <svg
            class="ml-4 w-6 h-6 fill-current transition-transform duration-200 ease-in-out"
            class:rotate-90={!showDropdown}
            class:-rotate-90={showDropdown}
          >
            <use xlink:href={`${SPRITESHEET_URL}#chevron-right`} />
          </svg>
        </button>
        <ul
          class="bg-white lg:shadow-md lg:absolute overflow-hidden pb-3 z-30"
          class:max-h-0={!showDropdown}
          class:max-w-0={!showDropdown}
          class:max-h-auto={showDropdown}
          class:max-w-auto={showDropdown}
        >
          {#each childLinks.slice(initialDesktopLinks) as { url, text, target }}
            <li>
              {#if currentPage !== text}
                <BaseLink
                  {url}
                  {target}
                  className="block w-full px-4 py-3 font-medium text-blue-cerulean hover-hover:hover:text-blue-dark-navy hover-hover:hover:bg-blue-bright-cyan focus:relative 
                  focus:outline-none active:shadow-inset-active focus:shadow-inset-focus"
                >
                  {text}
                </BaseLink>
              {:else}
                <div class="max-w-max mx-4 mb-2 pt-3 pb-1 font-medium border-b-2 border-blue-robin-egg">
                  {text}
                </div>
              {/if}
            </li>
          {/each}
        </ul>
      </li>
    {/if}
  </ul>
</nav>
